<template>
  <Card v-if="loaded" :padding="8">
    <p slot="title">Главная</p>
    <a slot="extra" v-on:click="handleModal">
      Редактировать
    </a>
    <Modal
      :mask-closable="false"
      title="Редактирование"
      v-model="modal"
      :loading="saving"
      v-on:on-ok="handleSave"
      :ok-text="!!percentage ? `${percentage}%` : 'Сохранить'"
    >
      <Form
        ref="form"
        :model="model"
        :rules="rules"
      >
        <FormItem label="Аватар" prop="avatar">
          <Upload
            v-model="model.avatar"
            :max='102400'
            unit="100 Кб."
            accept=".jpg, .jpeg, .png"
          />
        </FormItem>
        <FormItem label="Наименование" prop="name">
          <Input
            v-model="model.name"
          />
        </FormItem>
        <FormItem label="Краткое описание" prop="description">
          <Input
            type="textarea"
            autosize
            v-model="model.description"
          />
        </FormItem>
        <FormItem label="Телефон" prop="phone">
          <Input
            v-model="model.phone"
          />
        </FormItem>
        <FormItem label="Email" prop="email">
          <Input
            v-model="model.email"
          />
        </FormItem>
        <FormItem label="Адрес" prop="address">
          <Input
            v-model="model.address"
          />
        </FormItem>
        <FormItem label="Фотографии" prop="photos">
          <Upload
            v-model="model.photos"
            :max='5242880'
            unit="5 Мб."
            multiple
            accept=".jpg, .jpeg, .png"
          />
        </FormItem>
      </Form>
    </Modal>
    
    <div class="element head">
      <img
        v-if="!!model.avatar"
        class="avatar" 
        :src="model.avatar[0].url"
      />
      <div v-else class="avatar-empty"/>
      <span>{{model.name}}</span>
    </div>
    <div class="element">
      <p>{{model.description}}</p>
    </div>
    <div class="element">
      <p><b>Телефон</b></p>
      <p>{{model.phone}}</p>
    </div>
    <div class="element">
      <p><b>Email</b></p>
      <p>{{model.email}}</p>
    </div>
    <div class="element">
      <p><b>Адрес</b></p>
      <p>{{model.address}}</p>
    </div>
    <div class="element">
      <p><b>Фотографии</b></p>
      <div class="photos">
        <a 
          v-for="(item, index) in model.photos"
          :key="`item ${index}`"
          target="_blank" 
          rel="noopener noreferrer" 
          :href="item.url"
        >
          <img :src="item.url"/>
        </a>
      </div>
    </div>
  </Card>
  <Spin v-else size="large" fix/>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

import Upload from '../components/Upload';

import storage from '../plugins/storage';

export default {
  components: { Upload },
  data() {
    return {
      id: null,
      loaded: false,
      modal: false,
      saving: true,
      percentage: null,
      model: {
        name: null,
        description: null,
        phone: null,
        email: null,
        address: null,
        avatar: null,
        photos: null
      },
      rules: {
        name: [{ required: true, message: ' ', pattern: /([^\s])/ }],
        description: [{ required: true, message: ' ', pattern: /([^\s])/ }],
        phone: [{ required: true, message: ' ', pattern: /([^\s])/ }],
        email: [{ required: true, message: ' ', pattern: /([^\s])/ }],
        address: [{ required: true, message: ' ', pattern: /([^\s])/ }]
      }
    }
  },
  async mounted() {
    const email = firebase.auth().currentUser.email;

    const ref = firebase.database().ref(`institutions`)
    .orderByChild('admin').equalTo(email);
    const snapshot = await ref.once('value');
    const array = [];
    
    snapshot.forEach(childSnapshot => {
      const element = childSnapshot.val();
      element.id = childSnapshot.key;
      array.push(element);
    });

    if(array.length > 0) {
      const institution = array[0];

      if(!institution.active) {
        await firebase.auth().signOut();

        this.$router.push('/auth');
      }

      this.id = institution.id;
      this.model = {
        name: institution.name,
        description: institution.description,
        phone: institution.phone,
        email: institution.email,
        address: institution.address,
        avatar: institution.avatar,
        photos: institution.photos
      };
    }

    this.loaded = true;
  },
  methods: {
    handleModal() {
      this.modal = true;
    },
    async handleSave() {
      const valid = await new Promise(
        resolve => this.$refs.form.validate(valid => resolve(valid))
      );

      if(!valid) {
        this.$Message.error("Необходимо заполнить поля");
        this.saving = false;
        await this.$nextTick();
        this.saving = true;
        return;
      }

      await this.save();
    },
    async save() {
      try {
        this.model.avatar = await storage.upload(
          this.model.avatar,
          `institutions/${this.id}/avatar/`,
          percentage => this.percentage = percentage
        );

        this.model.photos = await storage.upload(
          this.model.photos,
          `institutions/${this.id}/photos/`,
          percentage => this.percentage = percentage
        );

        const ref = firebase.database().ref(`institutions/${this.id}`);

        await ref.update(this.model);

        this.$Message.success("Успешно сохранено");

        this.modal = false;
      }
      catch(error) {
        console.log(error);
        
        this.$Message.error("Ошибка");

        this.saving = false;
        await this.$nextTick();
        this.saving = true;
      }
    }
  }
}
</script>

<style scoped>
.element {
  padding: 8px;
}
.head {
  display: flex;
  align-items: center;
}
.head span {
  margin-left: 16px;
  font-size: 24px;
  font-weight: bold;
}
.avatar {
  width: 75px;
  height: 75px;
  border-radius: 37.5px;
}
.avatar-empty {
  width: 75px;
  height: 75px;
  border-radius: 37.5px;
  background-color: rgb(240, 240, 240);
}
.photos {
  display: flex;
  overflow: auto;
}
.photos img:first-child {
  margin-left: 0;
}
.photos img {
  margin: 8px;
  width: 100px;
  height: 100px;
  border-radius: 4px;
}
</style>